import { getCommonLabelTheme } from "./mark";

export const markArea = {
    area: {
        style: {
            fill: {
                type: "palette",
                key: "axisDomainColor",
                a: .25
            }
        }
    },
    label: getCommonLabelTheme()
};
//# sourceMappingURL=mark-area.js.map
